import { render, staticRenderFns } from "./LmModalError.vue?vue&type=template&id=4c7c1d0c"
import script from "./LmModalError.vue?vue&type=script&lang=js"
export * from "./LmModalError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports